import React from "react";
import { useUserContext } from "../context/user.context";
import AppLayout from "./AppLayout";
import { DASHBOARD_MENU } from "./SideBar/SideMenu";
import { useTranslation } from "react-i18next";

const DashboardLayout = () => {
    const { isGlobalUserAdmin, isUserAdmin } = useUserContext();
    const {t} = useTranslation();

    const superAdminLink = {
        menutitle: `${t("sideBar.adminPanel")}`,
        Items: [
            {
                path: `${process.env.PUBLIC_URL}/admin`,
                icon: 'ti-user',
                type: 'link',
                active: false,
                selected: false,
                title: `${t("sideBar.administration")}`,
                highlighted: true
                //disabled: true
            },
        ]
    }
    
    const menu = (isGlobalUserAdmin || isUserAdmin) ? [superAdminLink, ...DASHBOARD_MENU()] : DASHBOARD_MENU()
    return (<AppLayout SideMenuLinks={menu} />)
}

export default DashboardLayout